import { render, staticRenderFns } from "./FilmtypeCategoryEditor.vue?vue&type=template&id=17d2c471"
import script from "./FilmtypeCategoryEditor.vue?vue&type=script&lang=js"
export * from "./FilmtypeCategoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports